import React from 'react';

const featuresData = [
  {
    title: 'AI-Powered Insights',
    description: 'Advanced analytics to understand enterprise learning patterns.'
  },
  {
    title: 'Out-of-the-box Integrations',
    description: 'Connect to Coursera for Business, Udemy for Business, LinkedIn Learning, and more instantly.'
  },
  {
    title: 'Customizable Dashboards',
    description: 'Tailor visualizations to meet your organization’s needs.'
  },
  {
    title: 'Enterprise-grade Security',
    description: 'Built-in compliance and single sign-on support.'
  }
];

const Features = () => (
  <section id="features" className="features">
    <h2>Key Features</h2>
    <div className="features-grid">
      {featuresData.map((f, i) => (
        <div key={i} className="feature-card">
          <h3>{f.title}</h3>
          <p>{f.description}</p>
        </div>
      ))}
    </div>
  </section>
);

export default Features;